module.exports = __webpack_public_path__ + "static/media/referring-domains-sample.0ccd6250.png";